import React from 'react'

const { version } = require('../../../package.json')

const VersionTagContainer = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-end',
      textAlign: 'right',
      alignItems: 'center',
      color: 'white',
      flex: 1
    }}>
      v{version}
    </div>
  )
}

export default VersionTagContainer



// WEBPACK FOOTER //
// ./src/components/globals/VersionTagContainer.js